// extracted by mini-css-extract-plugin
export default {"input_container":"date-input_input_container__HrzG8","tag-style":"date-input_tag-style__roW6a","input":"date-input_input__0nStc"};